<div (click)="toggleConnectionElementClicked()">
  <ng-container
    *ngIf="(serviceConnected$ | async) === true; then disconnectServiceView; else connectServiceView"
  ></ng-container>
</div>

<ng-template #connectServiceView>
  <ng-container *ngIf="useAlternateStyling; then alternateConnectView; else defaultConnectView"></ng-container>
</ng-template>

<ng-template #disconnectServiceView>
  <ng-container *ngIf="useAlternateStyling; then alternateDisconnectView; else defaultDisconnectView"></ng-container>
</ng-template>

<ng-template #alternateDisconnectView>
  <ng-content select="integrations-disconnect-element"></ng-content>
</ng-template>

<ng-template #defaultDisconnectView>
  <button mat-raised-button>
    {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECT_TO_SERVICE_ELEMENT.DISCONNECT_SERVICE' | translate }}
  </button>
</ng-template>

<ng-template #alternateConnectView>
  <ng-content select="integrations-connect-element"></ng-content>
</ng-template>

<ng-template #defaultConnectView>
  <button mat-raised-button>
    {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECT_TO_SERVICE_ELEMENT.CONNECT_SERVICE' | translate }}
  </button>
</ng-template>
